import * as React from "react"

import { AppPage } from "./AppPage"

type RouterProps = {
  location: any
}

export const ArchivedItemsPage: React.FC<RouterProps> = ({ location }) => <AppPage location={location} />
